module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/HomepageHero-fa61740f3f8fb7a76263e2f83d2642d4.png";